import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/Homepage';
import Footer from './components/Footer';
import BuildDocmaentation from './pages/BuildDocmentation';
import PointCloudModeling from './pages/PointCloudModeling';
import IndustrialScanningServices from './pages/IndustrialScanningServices';
import ConstructionScanningServices from './pages/ConstructionScanningServices';
import Contact from './pages/ContactPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import Enq from './components/Enq';
import EnqMail from './components/EnqMail';


export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route path='/BuildDocmentation' element={<BuildDocmaentation />} />
      <Route path='/PointCloudModeling' element={<PointCloudModeling />} />
      <Route path='/IndustrialScanningServices' element={<IndustrialScanningServices />} />
      <Route path='/ConstructionScanningServices' element={<ConstructionScanningServices />} />
      <Route path='/Contact' element={<ContactPage /> } />
      <Route path='/About' element={<AboutPage /> } />
      
      </Routes>
      {/* <Enq /> */}
  
      <Footer />
      
    </Router>
  );
}




